import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from "vuetify/es5/locale/pt";
import theme from "./theme";
import "@mdi/font/css/materialdesignicons.css";
import "@fontsource/poppins";
import store from "@/store";

Vue.use(Vuetify);

const defaultSavedTheme = store.getters["theme/defaultTheme"];

let currentTheme = theme;

if (defaultSavedTheme !== null) {
  currentTheme = defaultSavedTheme;
}

store.dispatch("theme/setDefaultTheme", theme);

export default new Vuetify({
  lang: {
    locales: {
      pt,
    },
    current: "pt",
  },
  theme: {
    dark: store.getters["common/isInDarkMode"],
    options: {
      customProperties: true,
      headingImg: currentTheme.headingImg,
    },
    themes: {
      name: currentTheme.name,
      light: currentTheme.light,
      dark: currentTheme.dark,
    },
  },
  icons: {
    iconfont: "mdi",
  },
  breakpoint: {
    thresholds: {
      xs: 600,
      sm: 1239,
      // md: 1516,
      md: 1439,
      lg: 1900,
    },
  },
});
